/**
 * set dom element sticky relative to parent container for .s-sticky-panel selectors
 */
import jQuery from 'jquery'

class stickyHeader {
  constructor(element, element2) {
    if ((!element, !element2)) {
      return false
    }

    this.$element = element
    this.$element2 = element2

    jQuery(window).on('resize', () => {
      this.ini()
    })

    jQuery(window).on('scroll', () => {
      this.ini()
    })
  }

  ini() {
    const stickyElement = jQuery(this.$element)
    const thresholdElement = jQuery(this.$element2)

    const scrollTop = jQuery(window).scrollTop()
    const parentOffsetTop = stickyElement.parent().offset().top
    const parentHeight = stickyElement.parent().outerHeight()
    const stickyHeight = stickyElement.outerHeight()
    const distanceFromTop = jQuery('.header__layer').outerHeight()

    const dif = jQuery(thresholdElement).offset().top - distanceFromTop

    // console.log(distanceFromTop, scrollTop, dif)

    if (
      scrollTop > dif &&
      scrollTop <
        parentOffsetTop + parentHeight - stickyHeight - distanceFromTop
    ) {
      stickyElement.css({
        position: 'fixed',
        top: distanceFromTop,
        width: jQuery(thresholdElement).outerWidth(),
        zIndex: 1,
      })
    } else if (
      scrollTop >=
      parentOffsetTop + parentHeight - stickyHeight - distanceFromTop
    ) {
      stickyElement.css({
        position: 'absolute',
        top: parentHeight - stickyHeight,
        zIndex: 1,
      })
    } else {
      stickyElement.removeAttr('style')
    }
  }
}
export default stickyHeader
